import Image from "react-image-enlarger";
import React from 'react';
import {useLocation} from 'react-router-dom';
import {works} from './workconfig';

function SingleSource({ src }) {
    const [zoomed, setZoomed] = React.useState(false);
  
    return (
        <Image
          style={{ width: "100%"}}
          zoomed={zoomed}
          src={src}
          onClick={() => setZoomed(true)}
          onRequestClose={() => setZoomed(false)}
        />
    );
}

function WorkItems() {
    const location = useLocation();
    const pathname = location.pathname.replace("/","");
    const currentWorkItemIndex = works.findIndex(workitem=>workitem.Assets===decodeURI(pathname).toLowerCase());
    let workPrevious,workPreviousTitle,workNext,workNextTitle,contextItems,title,assets;
    title = works[currentWorkItemIndex].Title.split("|")[0];
    assets = works[currentWorkItemIndex].Assets;
    contextItems = works[currentWorkItemIndex].ContextItems;

    const filteredWorks = works.filter(w => w.ContextItems && w.ContextItems.length > 0);
    const filteredIndex = filteredWorks.findIndex(workitem=>workitem.Assets===decodeURI(pathname).toLowerCase());

    if(filteredIndex===0){
        workPrevious=filteredWorks[filteredWorks.length-1].Assets;
        workPreviousTitle=filteredWorks[filteredWorks.length-1].Title.split("|")[0];
    }
    else{
        workPrevious=filteredWorks[filteredIndex-1].Assets;
        workPreviousTitle=filteredWorks[filteredIndex-1].Title.split("|")[0];
    }

    if(filteredIndex===filteredWorks.length-1){
        workNext=filteredWorks[0].Assets;
        workNextTitle=filteredWorks[0].Title.split("|")[0];
    }
    else{
        workNext=filteredWorks[filteredIndex+1].Assets;
        workNextTitle=filteredWorks[filteredIndex+1].Title.split("|")[0];
    }

    return {workPrevious:workPrevious,workPreviousTitle:workPreviousTitle,workNext:workNext,workNextTitle:workNextTitle,contextItems:contextItems,title:title,assets:assets}
}

export {SingleSource,WorkItems}